export default __webpack_public_path__ + "static/media/Red0003.00387644.png";